import React from "react";
import { SavingsCalculatorProvider } from "./context";
import SavingsCalculator from "./views/SavingsCalculator";

const App = ({ config }) => (
    <SavingsCalculatorProvider config={config}>
        <SavingsCalculator />
    </SavingsCalculatorProvider>
);

export default App;
